import { Box, BoxProps } from "@chakra-ui/layout";
import { Row, RowProps } from "antd";

export const InputBaseWrapper = ({
  children,
  ...rest
}: BoxProps & RowProps) => (
  <Box as={Row} mb={4} {...rest}>
    {children}
  </Box>
);
